import { useParams, Outlet } from "react-router-dom";
import { useAppNavigation } from "../../hooks/useAppNavigation";
import { getApp } from "../../utils/appRegistry";
import { ShellAppProps } from "../../types/webos";

export function ShellApp() {
  const { appId } = useParams<{ appId: string }>();
  const { goHome } = useAppNavigation();

  const app = appId ? getApp(appId) : null;

  if (!app) {
    return (
      <div className="webos-container flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-xl font-semibold mb-2">App Not Found</h2>
          <p className="text-webos-text-secondary mb-4">
            The requested app "{appId}" could not be found.
          </p>
          <button onClick={goHome} className="webos-button">
            Go Home
          </button>
        </div>
      </div>
    );
  }

  const handleClose = () => {
    goHome();
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Escape") {
      handleClose();
    }
  };

  return (
    <div
      className="webos-container flex flex-col"
      onKeyDown={handleKeyDown}
      tabIndex={-1}
    >
      {/* App Header */}
      <div className="webos-app-header">
        <button
          onClick={handleClose}
          className="mr-3 p-1 rounded-lg hover:bg-webos-light-gray transition-colors"
          aria-label="Close app"
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>

        <div className="flex items-center space-x-3">
          <span className="text-2xl">{app.icon}</span>
          <span className="font-semibold">{app.name}</span>
        </div>
      </div>

      {/* App Content */}
      <div className="flex-1 overflow-hidden">
        <app.component onClose={handleClose} />
      </div>
    </div>
  );
}
